// Describing the shape of the user's slice of state
export interface User {
    login: string;
    supplierId?: string;
    company?: string;
    street?: string;
    zipCode?: string;
    city?: string;
    firstName?: string;
    lastName?: string;
    salutation?: string;
    phone?: string;
    email?: string;
    password?: string;
    roles?: string[];
    enabled?: boolean;
}

export interface UserState {
    isLoggedIn: boolean;
    user?: User;
    message?: string;
    supplierId?: string;
}

// Describing the different ACTION NAMES available
export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGIN_FAILED = "USER_LOGIN_FAILED";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_SAVE = "USER_SAVE";
export const USER_SAVE_FAILED = "USER_SAVE_FAILED";
export const SUPPLIER_ID_CHANGE = "SUPPLIER_ID_CHANGE";

interface UserLoginAction {
    type: typeof USER_LOGIN;
    payload: User;
}

interface UserLoginFailedAction {
    type: typeof USER_LOGIN_FAILED;
    payload: string;
}

interface UserLogoutAction {
    type: typeof USER_LOGOUT;
    meta: {
        username: string;
    };
}

interface UserSaveAction{
    type: typeof USER_SAVE;
    payload: User;
}

interface UserSaveFailedAction {
    type: typeof USER_SAVE_FAILED;
    payload: string;
}

interface SupplierIdChangedAction{
    type: typeof SUPPLIER_ID_CHANGE;
    payload: string;
}

export type UserActionTypes = UserLoginAction | UserLoginFailedAction | UserLogoutAction | UserSaveAction | UserSaveFailedAction | SupplierIdChangedAction;
